import { cn } from '@/lib/utils';
import { FIELD_CLASS } from '@/components/ui/input';
import type { ComponentProps } from 'react';

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(FIELD_CLASS, 'min-h-24 resize-y leading-relaxed', className)}
      {...props}
    />
  );
}
